import React, { Component } from 'react'
import copy from 'fast-copy'
import { connect } from 'react-redux'
import { 
	updateTask,
	getTrackedTime
} from 'state/actions'

import {
	getSessionSeconds,
	textTimeString
} from 'utils'

import moment from 'moment'

class TaskEstimate extends Component {
	state = {
		inputValue: '',
		isFocused: false,
		isLoadingTracked: false,
		hasLoadedTracked: false
	}

	inputRef = null

	handleChange = e => {
		let value = e.target.value

		if(value.length == 1){
			const isNumber = /\d/.test(value)

			if(!isNumber){
				// Don't let anyone start with a . or :
				return
			}
		}

		value = value.replace(/[^0-9.:]/g, "")

		let indexOfFirstColon = value.indexOf(':')
		let indexOfFirstDot = value.indexOf('.')

		if(indexOfFirstColon !== -1 && indexOfFirstDot !== -1){
			// cause ya can't have both.

			if(indexOfFirstColon < indexOfFirstDot){
				value = value.split('.').join('')
			}else{
				value = value.split(':').join('')
			}
		}

		// we're doing this again as it might change 
		indexOfFirstColon = value.indexOf(':')
		indexOfFirstDot = value.indexOf('.')

		// if it's got a colon, remove the dot. No need to vice-versa.
		if(indexOfFirstColon !== -1){
			value = value.split(':')
			value = value.shift() + ':' + value.join('')
		}else if(indexOfFirstDot !== -1){
			value = value.split('.')
			value = value.shift() + '.' + value.join('')
		}

		if(value.length > 6){
			value = value.substring(0, 6)
		}

		this.setState({
			inputValue: value
		})
	}

	setFocus = isFocused => {
		const {
			task
		} = this.props

		if(task.isRecurredDuplicate){
			return 
		}

		let state = {
			...this.state
		}

		state.isFocused = isFocused

		if(!isFocused){
			this.saveEstimate()

			if(this.inputRef){
				this.inputRef.blur()
			}
		}else{
			state.inputValue = this.convertMinutesToColon(this.props.task.estimated_minutes)
		}

		this.setState(state)
	}

	convertMinutesToColon = minutes => {
		if(minutes && !isNaN(minutes)){
			/* if(parseInt(minutes) < 10){
				minutes *= 10
			} */

			const duration = moment.duration({"minutes": minutes})

			let hoursString = Math.floor(duration.asHours())
			let minutesString = duration.minutes()
			let result = ''

			if(hoursString < 10 || hoursString === 0){
				hoursString = '0'+hoursString
			}

			if(minutesString < 10 || minutesString === 0){
				minutesString = '0'+minutesString
			}

			result = hoursString+':'+minutesString

			return result
		}else{
			return ''
		}
	}

	saveEstimate = _ => {
		const {
			inputValue
		} = this.state

		let totalMinutes = 0

		var indexOfFirstColon = inputValue.indexOf(':')
		var indexOfFirstDot = inputValue.indexOf('.')

		if(indexOfFirstColon !== -1){
			const values = inputValue.split(':')
			const firstValue = parseInt(values[0])

			totalMinutes += firstValue*60

			if(values[1]){
				const secondValue = parseInt(values[1])

				totalMinutes += secondValue
			}
		}else if(indexOfFirstDot !== -1){
			// parseFloat would probably make this half simpler
			const values = inputValue.split('.')
			const firstValue = parseInt(values[0])

			totalMinutes += firstValue*60

			if(values[1]){
				let secondValue = parseInt(values[1])

				// if it's got a single decimal, e.g 1.3
				if(secondValue < 10){
					secondValue *= 10
				}

				totalMinutes += (secondValue/100) * 60
			}
		}else if(!isNaN(parseInt(inputValue))){
			totalMinutes = (inputValue * 60)
		}

		if(!isNaN(totalMinutes)){
			const tempTask = copy(this.props.task)

			tempTask.estimated_minutes = totalMinutes

			this.props.updateTask(tempTask)

			this.setState({
				inputValue: ''
			})
		}
	}

	getTrackedTime = _ => {
		const {
			getTrackedTime,
			task
		} = this.props

		getTrackedTime(task, _ => {
			this.setState({
				hasLoadedTracked: true
			})
		})
	}

	getTrackedText = _ => {
		const {
			task,
			allSessions
		} = this.props

		const {
			hasLoadedTracked
		} = this.state
		
		if(!hasLoadedTracked){
			return 'Loading tracked...'
		}else{
			let totalSecondsTracked = 0

			task.sessions && task.sessions.forEach(sessionId => {
				const session = allSessions[sessionId]

				if(session && !session.deleted_at){
					const seconds = getSessionSeconds(session)

					totalSecondsTracked += seconds
				}
			})

			if(totalSecondsTracked){
				let returnString = `${textTimeString(totalSecondsTracked, 'seconds')} tracked`

				if(task.estimated_minutes){
					const minutesTracked = totalSecondsTracked/60
					const percentTracked = Math.round((minutesTracked/task.estimated_minutes) * 100)

					if(percentTracked){
						returnString += ` (${percentTracked}%)`
					}
				}

				return returnString
			}else{
				return 'No time tracked'
			}
		}
	}

	render() {
		const {
			inputValue,
			isFocused
		} = this.state

		const {
			task
		} = this.props

		let className = 'task-estimate tooltip-trigger'

		if(!task.estimated_minutes){
			className += ' empty'
		}

		let valueString = inputValue

		if(!isFocused){
			valueString = task.estimated_minutes ? this.convertMinutesToColon(task.estimated_minutes) : '(None)'
		}

		return (
			<div 
				className={className}
				onMouseEnter={this.getTrackedTime}
			>
				<input 
					ref={ref => this.inputRef = ref}
					type="text" 
					placeholder="00:00"
					onKeyPress={e => {(e.key === 'Enter') ? this.setFocus(false) : null }} 
					onBlur={_ => this.setFocus(false)}
					onChange={this.handleChange}
					value={valueString}
					onFocus={_ => this.setFocus(true)}
					disabled={!!task.isRecurredDuplicate}
				/>
				<div className="tooltip">
					{ !valueString ? 'Estimate (hrs/mins)' : null }
					{ !valueString ? <br /> : null }
					{ this.getTrackedText() }
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allSessions: state.account.entities.sessions
	}
}

export default connect(mapStateToProps, { 
	updateTask,
	getTrackedTime
})(TaskEstimate)